<template>
  <div
    :class="[$style.container, $style[theme]]"
    @click.stop
  >
    <div
      :class="$style.playWrap"
      @click="toggleAudio"
    >
      <RadialProgressBar
        :diameter="36"
        :innerStrokeWidth="2" :strokeWidth="2"
        startColor="#00b764" stopColor="#00b764" innerStrokeColor="#ffffff"
        :completedSteps="currentTime"
        :totalSteps="audioDuration"
        :animateSpeed="100"
        :class="$style.progress"
      />
      <BaseIcon
        :name="playbackIcon"
        :class="$style.play"
      />
    </div>
    <BaseIcon
      custom
      name="audioSpectrum"
      :class="$style.wave"
    />
    <BaseIcon
      custom
      name="audioSpectrum"
      :class="$style.wave"
    />
    <BaseIcon
      custom
      name="audioSpectrum"
      :class="$style.wave"
    />
    <BaseIcon
      custom
      name="audioSpectrum"
      :class="$style.wave"
    />
    <audio
      ref="player"
      :src="message.payload.link"
      style="display: none;"
      preload="metadata"
    ></audio>
    <div :class="$style.time">{{ elapsedTime }} / {{ totalTime }}</div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
  name: 'message-content-voice',
  components: {
    RadialProgressBar
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentTime: 0,
      audioDuration: 0,
      audioLoaded: false,
      isPlaying: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      const audio = this.$refs.player
      audio.addEventListener('loadedmetadata', this.initSlider)
      audio.addEventListener('canplay', () => {
        this.audioLoaded = true
      })
      audio.addEventListener('timeupdate', this.playbackListener)
      audio.addEventListener('ended', this.endListener)
      audio.addEventListener('pause', this.pauseListener)
    })
  },
  computed: {
    playbackIcon () {
      return this.isPlaying ? 'pause' : 'play'
    },
    totalTime () {
      return this.convertTime(this.audioDuration)
    },
    elapsedTime () {
      return this.convertTime(this.currentTime)
    }
  },
  methods: {
    initSlider () {
      const audio = this.$refs.player
      if (audio) {
        this.audioDuration = audio.duration
      }
    },
    // Convert audio current time from seconds to min:sec display
    convertTime (seconds) {
      if (!seconds) return '00:00'
      const format = val => `0${Math.floor(val)}`.slice(-2)
      const minutes = (seconds % 3600) / 60
      return [minutes, seconds % 60].map(format).join(':')
    },
    playbackListener () {
      this.currentTime = this.$refs.player.currentTime
    },
    pauseListener () {
      this.isPlaying = false
      // this.listenerActive = false
      // this.cleanupListeners()
    },
    // Function to run when audio play reaches the end of file
    endListener () {
      this.isPlaying = false
      this.currentTime = 0
      // this.listenerActive = false
      // this.cleanupListeners()
    },
    cleanupListeners () {
      var audio = this.$refs.player
      audio.removeEventListener('timeupdate', this.playbackListener)
      audio.removeEventListener('ended', this.endListener)
      audio.removeEventListener('pause', this.pauseListener)
    },
    toggleAudio () {
      const audio = this.$refs.player
      if (audio.paused) {
        audio.play()
        this.isPlaying = true
      } else {
        audio.pause()
        this.isPlaying = false
      }
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
  align-items: center;
}
.green{
  .playWrap{
    background-color: rgba($white, 0.15);
  }
  .play{
    color: $white;
  }
  .wave {
    color: $white;
  }
}
.playWrap {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($main-bg-colored, 0.15);
  margin-right: 8px;
  flex-shrink: 0;
  position: relative;
}
.progress {
  position: absolute;
}
.play {
  font-size: 16px;
  color: $text-colored;
}
.wave {
  font-size: 24px;
  color: $text-colored;
}

.time {
  margin-left: 8px;
}
</style>
